import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';
import { m2mApi } from '@doltech/core/lib/api/m2m.config';
import { components as ot } from '@doltech/dto';

export const startDoDictation = (id: string) =>
  apis.onlineTest.post<ot['schemas']['ResponseDTO']>(
    apiUrls.onlineTest.START_DICTATION,
    {},
    {
      params: { id },
    }
  );

export const getM2MDictationById = (id: string) =>
  m2mApi.get<ot['schemas']['DictationDTO']>(
    `${apis.onlineTestM2M.getBaseURL()}${apiUrls.onlineTest.DICTATION_BY_ID}`,
    {
      id,
    }
  );

export const getOTDictationById = (id: string) =>
  apis.onlineTest.get<ot['schemas']['DictationDTO']>(apiUrls.onlineTest.DICTATION_BY_ID, { id });
